// extracted by mini-css-extract-plugin
module.exports = {"boxUnselect":"_1uCDTKCTVgACskdq8JyFHU","title":"_3lNrMzja2gAiz8BIuTj5SR","boxSelect":"_1j92oeOuDjO1F15zGSNTT5"};